import { Button, Form, Input, Spin } from 'antd'
import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate, useParams } from 'react-router-dom'

import routes from '@/constants/routes'
import { WashingMachinePart } from '@/types'
import { UpdateWashingMachinePartRequest } from '@/types/apis/washingMachinePart/UpdateWashingMachinePartRequest'

import { SpaceCustom } from '../../style'

type Props = {
  getLoading?: boolean
  getWashingMachinePartResponse: WashingMachinePart | undefined
  onSubmit: (formValues: UpdateWashingMachinePartRequest) => void
}

const UpdateWashingMachinePartForm = ({ getLoading, getWashingMachinePartResponse, onSubmit }: Props) => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const { id } = useParams()

  const [form] = Form.useForm<WashingMachinePart>()

  const handleSubmit = (values: WashingMachinePart) => {
    if (id) {
      const payload: UpdateWashingMachinePartRequest = {
        ...values,
        id: Number(id),
      }
      onSubmit(payload)
    }
  }

  useEffect(() => {
    if (getWashingMachinePartResponse) {
      form.setFieldsValue({
        name: getWashingMachinePartResponse.name,
        manufacturer: getWashingMachinePartResponse.manufacturer,
        supplier: getWashingMachinePartResponse.supplier,
        price: getWashingMachinePartResponse.price,
        inventory: getWashingMachinePartResponse.inventory,
      })
    }
  }, [form, getWashingMachinePartResponse])

  return (
    <Spin spinning={getLoading}>
      <Form layout="vertical" onFinish={handleSubmit} form={form}>
        <Form.Item
          label={t('components.pages.washingMachinePart.update.form.name')}
          name="name"
          rules={[{ required: true, message: t('components.pages.washingMachinePart.update.form.requireName') }]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          label={t('components.pages.washingMachinePart.update.form.manufacturer')}
          name="manufacturer"
          rules={[{ required: true, message: t('components.pages.washingMachinePart.update.form.requireManufacture') }]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          label={t('components.pages.washingMachinePart.update.form.supplier')}
          name="supplier"
          rules={[{ required: true, message: t('components.pages.washingMachinePart.update.form.requireSupplier') }]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          label={t('components.pages.washingMachinePart.update.form.price')}
          name="price"
          rules={[{ required: true, message: t('components.pages.washingMachinePart.update.form.requirePrice') }]}
        >
          <Input type="number" min={0} />
        </Form.Item>

        <Form.Item
          label={t('components.pages.washingMachinePart.update.form.inventory')}
          name="inventory"
          rules={[{ required: true, message: t('components.pages.washingMachinePart.update.form.requireInventory') }]}
        >
          <Input type="number" min={0} />
        </Form.Item>

        <Form.Item>
          <SpaceCustom>
            <Button onClick={() => navigate(routes.washingMachinePart.path)}>
              {t('components.pages.washingMachinePart.update.form.cancel')}
            </Button>
            <Button type="primary" htmlType="submit">
              {t('components.pages.washingMachinePart.update.form.save')}
            </Button>
          </SpaceCustom>
        </Form.Item>
      </Form>
    </Spin>
  )
}

UpdateWashingMachinePartForm.displayName = 'UpdateWashingMachinePartForm'
export default UpdateWashingMachinePartForm
